/* ─── JHN Docs — interface façon Google Docs (éditeur plein écran) ───────────── */

.standalone { height: 100vh; height: 100dvh; overflow: hidden; }

:root {
  --gdoc-blue: #1a73e8;
  --gdoc-blue-600: #1765d1;
}
[data-theme="light"] {
  --gdoc-canvas: #eef1f4;
  --gdoc-page: #ffffff;
  --gdoc-bar: #ffffff;
  --gdoc-tool: #edf2fa;
  --gdoc-line: rgba(20,16,10,0.10);
  --gdoc-ink: #3c4043;
}
[data-theme="dark"] {
  --gdoc-canvas: #0b0b0c;
  --gdoc-page: #1c1c1f;
  --gdoc-bar: #161618;
  --gdoc-tool: #232428;
  --gdoc-line: rgba(255,255,255,0.10);
  --gdoc-ink: #c9c7c2;
}

.gdoc { display: flex; flex-direction: column; height: 100%; background: var(--gdoc-canvas); }

/* ── En-tête ── */
.gdoc-header { display: flex; align-items: flex-start; gap: 14px; padding: 8px 16px 6px; background: var(--gdoc-bar);
  border-bottom: 1px solid var(--gdoc-line); }
.gdoc-home { flex: none; margin-top: 4px; }
.gdoc-home img { width: 40px; height: 40px; border-radius: 9px; }
.gdoc-headmain { flex: 1; min-width: 0; }
.gdoc-titlerow { display: flex; align-items: center; gap: 8px; }
.gdoc-title { font-size: 18px; font-weight: 500; color: var(--text); background: transparent; border: 1px solid transparent;
  border-radius: 6px; padding: 4px 8px; min-width: 60px; max-width: 520px; outline: none; }
.gdoc-title:hover { border-color: var(--gdoc-line); }
.gdoc-title:focus { border-color: var(--gdoc-blue); }
.gdoc-iconbtn { width: 30px; height: 30px; border: none; background: transparent; border-radius: 50%; color: var(--text-dim);
  cursor: pointer; display: grid; place-items: center; }
.gdoc-iconbtn:hover { background: var(--gdoc-tool); color: var(--coral); }
.gdoc-saved { font-size: 12.5px; color: var(--text-faint); margin-left: 6px; white-space: nowrap; }
.gdoc-saved.busy { color: var(--gdoc-blue); }

.gdoc-menubar { display: flex; gap: 2px; margin-top: 2px; flex-wrap: wrap; }
.gdoc-menu { border: none; background: transparent; color: var(--gdoc-ink); font-size: 13.5px; padding: 4px 8px;
  border-radius: 6px; cursor: pointer; }
.gdoc-menu:hover { background: var(--gdoc-tool); }

.gdoc-headright { display: flex; align-items: center; gap: 12px; margin-top: 4px; }
.gdoc-share { display: inline-flex; align-items: center; gap: 8px; height: 38px; padding: 0 18px; border: none; cursor: pointer;
  border-radius: 99px; background: var(--gdoc-blue); color: #fff; font-size: 14px; font-weight: 500;
  box-shadow: 0 1px 2px rgba(0,0,0,0.2); transition: background .2s; }
.gdoc-share:hover { background: var(--gdoc-blue-600); }
.gdoc-share svg { stroke: #fff; }

/* ── Barre d'outils (pilule façon Google Docs) ── */
.gdoc-toolbar-wrap { display: flex; justify-content: center; padding: 8px 12px; background: var(--gdoc-bar); }
.gdoc-toolbar.ql-toolbar.ql-snow { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 1px;
  background: var(--gdoc-tool); border: none; border-radius: 99px; padding: 3px 8px;
  width: fit-content; max-width: calc(100% - 16px); margin: 0 auto; justify-content: center; }
.gdoc-toolbar .ql-formats { margin: 0 3px 0 0 !important; display: inline-flex; align-items: center; }
.gdoc-toolbar .gdoc-grp { padding-right: 5px; border-right: 1px solid var(--gdoc-line); margin-right: 5px !important; }
.gdoc-toolbar .gdoc-grp:last-of-type, .gdoc-toolbar .ql-formats:last-child { border-right: none; margin-right: 0 !important; padding-right: 0; }

/* Réglage de taille « − 11 + » */
.gdoc-sizegrp { gap: 1px; }
.gdoc-size { width: 36px; height: 28px; text-align: center; border: 1px solid var(--gdoc-line); border-radius: 6px;
  background: transparent; color: var(--gdoc-ink); font-size: 13px; outline: none; }
.gdoc-size:focus { border-color: var(--gdoc-blue); }
.gdoc-step { width: 26px; }
/* Bouton zoom (label + chevron) */
.gdoc-zoom { width: auto !important; display: inline-flex !important; gap: 3px; padding: 0 8px; font-size: 13px; color: var(--gdoc-ink); }
.gdoc-zoom .zlabel { font-variant-numeric: tabular-nums; }
.gdoc-tb { width: 30px; height: 30px; border: none; background: transparent; border-radius: 6px; color: var(--gdoc-ink);
  cursor: pointer; display: grid; place-items: center; }
.gdoc-tb:hover { background: rgba(0,0,0,0.06); }
[data-theme="dark"] .gdoc-tb:hover { background: rgba(255,255,255,0.08); }

/* Boutons Quill */
.gdoc-toolbar.ql-snow button { width: 30px; height: 30px; border-radius: 6px; padding: 4px; }
.gdoc-toolbar.ql-snow button:hover { background: rgba(0,0,0,0.06); }
[data-theme="dark"] .gdoc-toolbar.ql-snow button:hover { background: rgba(255,255,255,0.08); }
.gdoc-toolbar.ql-snow .ql-stroke { stroke: var(--gdoc-ink); }
.gdoc-toolbar.ql-snow .ql-fill { fill: var(--gdoc-ink); }
.gdoc-toolbar.ql-snow .ql-picker { color: var(--gdoc-ink); }
.gdoc-toolbar.ql-snow button.ql-active, .gdoc-toolbar.ql-snow button:hover.ql-active { background: rgba(26,115,232,0.14); }
.gdoc-toolbar.ql-snow button.ql-active .ql-stroke { stroke: var(--gdoc-blue); }
.gdoc-toolbar.ql-snow button.ql-active .ql-fill { fill: var(--gdoc-blue); }
.gdoc-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label { border-color: var(--gdoc-line); }
.gdoc-toolbar.ql-snow .ql-picker-options { background: var(--gdoc-bar); border: 1px solid var(--gdoc-line);
  border-radius: 8px; box-shadow: 0 8px 24px rgba(0,0,0,.18); padding: 6px; }
.gdoc-toolbar.ql-snow .ql-picker-label { border-radius: 6px; }
.gdoc-toolbar.ql-snow .ql-picker-label:hover { background: rgba(0,0,0,0.06); }
[data-theme="dark"] .gdoc-toolbar.ql-snow .ql-picker-label:hover { background: rgba(255,255,255,0.08); }

/* Largeurs des sélecteurs */
.gdoc-toolbar .ql-header { width: 116px; }
.gdoc-toolbar .ql-font { width: 116px; }
.gdoc-toolbar .ql-size { width: 64px; }

/* Libellés FR des pickers (style / police / taille) */
.gdoc-toolbar .ql-picker.ql-header .ql-picker-label::before,
.gdoc-toolbar .ql-picker.ql-header .ql-picker-item::before { content: 'Texte normal'; }
.gdoc-toolbar .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.gdoc-toolbar .ql-picker.ql-header .ql-picker-item[data-value="1"]::before { content: 'Titre 1'; font-size: 18px; }
.gdoc-toolbar .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.gdoc-toolbar .ql-picker.ql-header .ql-picker-item[data-value="2"]::before { content: 'Titre 2'; font-size: 16px; }
.gdoc-toolbar .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.gdoc-toolbar .ql-picker.ql-header .ql-picker-item[data-value="3"]::before { content: 'Titre 3'; font-size: 14px; }

.gdoc-toolbar .ql-picker.ql-font .ql-picker-label::before,
.gdoc-toolbar .ql-picker.ql-font .ql-picker-item::before { content: 'Arial'; font-family: Arial, sans-serif; }
.gdoc-toolbar .ql-picker.ql-font .ql-picker-label[data-value="georgia"]::before,
.gdoc-toolbar .ql-picker.ql-font .ql-picker-item[data-value="georgia"]::before { content: 'Georgia'; font-family: Georgia, serif; }
.gdoc-toolbar .ql-picker.ql-font .ql-picker-label[data-value="times-new-roman"]::before,
.gdoc-toolbar .ql-picker.ql-font .ql-picker-item[data-value="times-new-roman"]::before { content: 'Times New Roman'; font-family: 'Times New Roman', serif; }
.gdoc-toolbar .ql-picker.ql-font .ql-picker-label[data-value="courier-new"]::before,
.gdoc-toolbar .ql-picker.ql-font .ql-picker-item[data-value="courier-new"]::before { content: 'Courier New'; font-family: 'Courier New', monospace; }
.gdoc-toolbar .ql-picker.ql-font .ql-picker-label[data-value="verdana"]::before,
.gdoc-toolbar .ql-picker.ql-font .ql-picker-item[data-value="verdana"]::before { content: 'Verdana'; font-family: Verdana, sans-serif; }
.gdoc-toolbar .ql-picker.ql-font .ql-picker-label[data-value="roboto"]::before,
.gdoc-toolbar .ql-picker.ql-font .ql-picker-item[data-value="roboto"]::before { content: 'Roboto'; font-family: Roboto, sans-serif; }

.gdoc-toolbar .ql-picker.ql-size .ql-picker-label::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item::before { content: '11'; }
.gdoc-toolbar .ql-picker.ql-size .ql-picker-label[data-value="9px"]::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item[data-value="9px"]::before { content: '9'; }
.gdoc-toolbar .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before { content: '10'; }
.gdoc-toolbar .ql-picker.ql-size .ql-picker-label[data-value="11px"]::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item[data-value="11px"]::before { content: '11'; }
.gdoc-toolbar .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before { content: '14'; }
.gdoc-toolbar .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before { content: '16'; }
.gdoc-toolbar .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before { content: '18'; }
.gdoc-toolbar .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before { content: '24'; }
.gdoc-toolbar .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before { content: '30'; }
.gdoc-toolbar .ql-picker.ql-size .ql-picker-label[data-value="36px"]::before,
.gdoc-toolbar .ql-picker.ql-size .ql-picker-item[data-value="36px"]::before { content: '36'; }

/* ── Corps : onglets + page ── */
.gdoc-body { flex: 1; min-height: 0; display: grid; grid-template-columns: 240px 1fr; }
.gdoc-tabs { border-right: 1px solid var(--gdoc-line); overflow: auto; padding: 18px 12px; background: var(--gdoc-bar); user-select: none; -webkit-user-select: none; }
.gdoc-tab-edit { flex: 1; min-width: 0; border: 1px solid var(--gdoc-blue); border-radius: 6px; padding: 2px 6px; font: inherit; font-size: 14px; background: var(--gdoc-bar); color: var(--text); outline: none; }
.gdoc-tabs-head { display: flex; align-items: center; gap: 8px; padding: 0 6px 10px; }
.gdoc-tabs-head b { font-size: 14px; font-weight: 600; flex: 1; }
.gdoc-tab-add { width: 28px; height: 28px; border: none; background: transparent; border-radius: 8px; color: var(--gdoc-ink); cursor: pointer; display: grid; place-items: center; }
.gdoc-tab-add:hover { background: var(--gdoc-tool); }
.gdoc-tabs-list { display: flex; flex-direction: column; gap: 2px; }
.gdoc-tab { display: flex; align-items: center; gap: 9px; padding: 9px 10px; border-radius: 10px; cursor: pointer; color: var(--gdoc-ink); font-size: 14px; }
.gdoc-tab:hover { background: var(--gdoc-tool); }
.gdoc-tab.active { background: rgba(26,115,232,.14); color: var(--gdoc-blue); font-weight: 600; }
.gdoc-tab-ic { display: inline-flex; opacity: .8; }
.gdoc-tab-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.gdoc-tab-more { width: 24px; height: 24px; border: none; background: transparent; border-radius: 6px; color: inherit; cursor: pointer; opacity: .45; display: grid; place-items: center; }
.gdoc-tab:hover .gdoc-tab-more { opacity: .85; }
.gdoc-tab-more:hover { opacity: 1 !important; background: rgba(0,0,0,.08); }

.gdoc-canvas { overflow: auto; min-width: 0; padding: 28px 20px 80px; }
.gdoc-page { width: 816px; max-width: 100%; min-height: 1056px; margin: 0 auto; background: var(--gdoc-page);
  border: 1px solid var(--gdoc-line); border-radius: 2px; box-shadow: 0 1px 3px rgba(0,0,0,.18), 0 8px 30px rgba(0,0,0,.10); }
.gdoc-editor { height: 100%; }
.gdoc .ql-container.ql-snow { border: none; font-family: Arial, var(--font); font-size: 11pt; color: var(--text); }
.gdoc .ql-editor { padding: 96px 96px 120px; min-height: 1056px; line-height: 1.5; }
.gdoc .ql-editor.ql-blank::before { left: 96px; right: 96px; color: var(--text-faint); font-style: normal; }

/* Polices appliquées au contenu */
.ql-font-georgia { font-family: Georgia, serif; }
.ql-font-times-new-roman { font-family: 'Times New Roman', serif; }
.ql-font-courier-new { font-family: 'Courier New', monospace; }
.ql-font-verdana { font-family: Verdana, sans-serif; }
.ql-font-roboto { font-family: Roboto, sans-serif; }

.gdoc-error { display: grid; place-content: center; gap: 10px; text-align: center; height: 100%; color: var(--text-dim); }
.gdoc-error a { display: inline-block; margin-top: 8px; }

@media (max-width: 900px) {
  .gdoc-header { flex-wrap: wrap; }
  .gdoc-headright { width: 100%; justify-content: flex-end; margin-top: 0; }
  .gdoc-body { grid-template-columns: 1fr; }
  .gdoc-tabs { display: none; }
  .gdoc .ql-editor { padding: 48px 40px 80px; }
  .gdoc .ql-editor.ql-blank::before { left: 40px; right: 40px; }
  .gdoc-page { min-height: auto; }
}

/* Impression : seule la page, sans chrome */
@media print {
  .gdoc-header, .gdoc-toolbar-wrap { display: none !important; }
  .gdoc-canvas { overflow: visible; padding: 0; }
  .gdoc-page { box-shadow: none; border: none; width: auto; }
}
